import { useMutation } from "@tanstack/react-query";
import { useToast } from "../components/ui/use-toast";
import { fetch } from "./fetch";

/** Supplier bank details (brief §6d). Saving also updates the supplier's
 *  company record so the next charter with them starts pre-filled. */
export type SupplierBankBody = {
  currency?: string | null;
  beneficiaryName?: string | null;
  iban?: string | null;
  swift?: string | null;
  accountNumber?: string | null;
  routingNumber?: string | null;
  bank?: string | null;
  beneficiaryAddress?: string | null;
  reference?: string | null;
};

export const useBookingSupplierBankMutation = (bookingId: string, onDone: () => void) => {
  const { toast } = useToast();
  return useMutation({
    mutationFn: (body: SupplierBankBody) =>
      fetch<{ data: { route: string; companyUpdated: boolean } }>(
        `/api/bookings/${bookingId}/supplier-bank`,
        "PATCH",
        body,
      ),
    onSuccess: (res: any) => {
      toast({
        title: "Bank details saved",
        description: res?.data?.companyUpdated
          ? "Also saved against the supplier's company record."
          : "Saved against this booking.",
      });
      onDone();
    },
    onError: (error: any) =>
      toast({ title: "Error", description: error.message || "Failed to save bank details.", variant: "destructive" }),
  });
};
